import React, { useCallback } from 'react'
import { Box, Typography, Grid } from '@material-ui/core'

import { NoCampaignsImage } from '../../../../Assets/Images/NoCampaignsImage'
import { CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE } from '../../../../shared/constants'
import { PageTitle } from 'Components/PageTitle'

import { EmptyStateDropdownBtn } from '../CampaignEmptyStateButtons'
import EmptyStateMessage from '../EmptyStateMessage'
import usePosthogAnalyticsCampaignEmptyState from './hooks/usePosthogAnalyticsCampaignEmptyState'

const EmptyState = ({
  classes,
  handleCreateCampaign,
  isSelfServeEnabled,
  enabledChannels,
  route,
}) => {
  const noChannelsEnabled = enabledChannels.length < 1
  const { emitAnalyticsEvent } = usePosthogAnalyticsCampaignEmptyState()

  const handleClick = useCallback(
    async option => {
      await handleCreateCampaign(option)
      emitAnalyticsEvent(option)
    },
    [handleCreateCampaign],
  )

  return (
    <React.Fragment>
      {noChannelsEnabled && (
        <EmptyStateMessage title="Sorry, there are currently no channels available to create a campaign in your country." />
      )}
      <Box className={classes.campaignWrapper}>
        <PageTitle className={classes.title}>
          {CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE[route]}
        </PageTitle>
        <Grid
          container
          alignItems="center"
          direction="column"
          justifyContent="center"
          className={classes.centered}
        >
          <NoCampaignsImage />
          {noChannelsEnabled ? (
            <Typography className={classes.noChannel}>
              No channels available to create a campaign in your country.
            </Typography>
          ) : (
            <React.Fragment>
              <Typography className={classes.btnTitle}>
                Let's create your first campaign!
              </Typography>
              {isSelfServeEnabled && (
                <EmptyStateDropdownBtn
                  handleCreateCampaign={handleClick}
                  campaignOptions={enabledChannels}
                  classes={classes}
                />
              )}
            </React.Fragment>
          )}
        </Grid>
      </Box>
    </React.Fragment>
  )
}
export default EmptyState
